<template>
  <div class="student-manage">
    <TableLayout>
      <template slot="search-form">
        <section class="btn-actions">
          <div class="fl">
            <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="60px" inline>
              <el-form-item prop="gradeType">
                <el-select style="width:160px; marginLeft: 13px" v-model="searchForm.gradeType" placeholder="请选择" size="small" @change="getStudentInformation()">
                  <el-option label="全部" value="2" ></el-option>
                  <el-option label="未结课" :value="0" ></el-option>
                  <el-option label="已结课" :value="1" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级:" prop="gradeName">
                <el-input v-model="searchForm.gradeName" clearable size="medium" class="item-width" @keyup.enter.native="keyDownEnter"></el-input>
              </el-form-item>
              <el-form-item label="专业:" prop="professionId">
                <el-select v-model="searchForm.professionId" placeholder="请选择专业名称" clearable size="small" @change="getStudentInformation()">
                  <el-option v-for="item in majorNameOptions" :key="item.id" :label="item.dictionaryName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名:" prop="studentName">
                <el-input v-model="searchForm.studentName" clearable size="medium" class="item-width" @keyup.enter.native="keyDownEnter"></el-input>
              </el-form-item>
              <el-form-item label="手机号:" prop="mobile">
                <el-input v-model="searchForm.mobile" clearable size="medium" class="item-width" @keyup.enter.native="keyDownEnter"></el-input>
              </el-form-item>
              <section style="">
                <el-button size="small" type="primary" @click="search()" >搜索</el-button>
              </section>
            </el-form>
          </div>
        </section>
      </template>
      <!-- 表格和分页 :height="tableHeight - (showObj ? 34 : 0)" -->
      <template slot="table-wrap">
        <el-table ref="tableList" :height="tableHeight" :row-style="selectedstyle" :row-class-name="tableRowClassName" :header-cell-style="{background:'#1e87f1', color:'#fff'}"
          v-loading="isWorking.loading" :data="tableData.list"
        >
          <el-table-column prop="studentNo" label="学号" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column label="性别" align="center">
            <template slot-scope="{ row }"> <span>{{ row.gender === 0 ? '男' : row.gender === 1 ? '女' : '' }}</span> </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
          <el-table-column prop="gradeName" label="班级" align="center">
            <template slot-scope="{ row }"><span>{{ row.levelNum + row.gradeName }}</span></template>
          </el-table-column>
          <el-table-column prop="professionName" label="专业" align="center"></el-table-column>
          <el-table-column label="注册时间" align="center">
            <template slot-scope="{ row }"><span>{{ formatDate(row.createTime) }}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="320px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleEditStudent(row)">修改信息</el-button>
              <el-button type="text" @click="handleResetPassword(row)">重置密码</el-button>
              <el-button type="text" @click="handleChangeClass(row)">更换班级</el-button>
              <el-button type="text" @click="studyDetails(row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="fix-footer">
          <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange($event, { msg: true })"
            :pagination="tableData.pagination"
          ></pagination>
        </div> -->
      </template>
    </TableLayout>
    <Dialog :title="dialogTitle" :visible.sync="dialogVisible" @dialog-confirm="dialogHandleConfirm" >
      <el-form ref="dialogForm" :model="dialogForm" label-width="70px" class="class-form" label-position="left">
        <template v-if="dialogType === dialogTypeArr[0] || dialogType === dialogTypeArr[1]">
          <el-row>
            <el-col :span="11">
              <el-form-item label="学号" prop="number" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-input style="width:100%" placeholder="请输入学号" show-word-limit size="small" maxlength="20" v-model="dialogForm.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label="姓名" prop="name" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-input placeholder="请输入姓名" show-word-limit size="small" maxlength="20" v-model="dialogForm.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="性别" prop="gender" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-select style="width:100%" placeholder="请选择性别" size="small" v-model="dialogForm.gender" >
                  <el-option label="男" value="male" ></el-option>
                  <el-option label="女" value="female" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label="手机号" prop="phone" class="inline-item" :rules="phoneRule">
                <el-input placeholder="请输入手机号" show-word-limit size="small" maxlength="11" v-model="dialogForm.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="dialogType === dialogTypeArr[3]">
          <div class="class-change-prompt">请注意：一旦该学员更换班级，其所有课程历史数据将被清空，请谨慎操作。</div>
          <el-form-item label="班级" prop="classId" :rules="{ required: true, message: ' ', trigger: 'blur' }">
            <el-select style="width:100%" placeholder="请选择班级" v-model="dialogForm.classId" filterable>
              <!-- <el-option v-for="item in classNameOptions" :key="item.id" :label="item.name" :value="item.id" :disabled="item.id === classId"></el-option> -->
              <el-option v-for="item in classNameOptions" :key="item.id" :label="item.levelName + item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import { comMethod } from '@/utils/index.js'
import Pagination from '@/components/common/pagination'
import Dialog from './Dialog';
import BaseTable from '@/components/BaseTable'
import TableLayout from '@/layout/TableLayout'
import { formatDate } from '@/utils/formatDate.js';
import { classServer, studentServer, keyServer,   studentCenterServer } from '@/api/api';
export default {
  name: 'StudentManage',
  extends: BaseTable,
  components: { TableLayout, Pagination, Dialog },
  data () {
    return {
      tableHeight: 300,
      searchForm: {
        gradeType: 0,
        professionId: '',
        gradeName: '',
        studentName: '',
        mobile: ''
      },
      classId: '',
      studentId: '',
      majorNameOptions: [],
      classNameOptions: [],
      dialogTypeArr: ['addStudent', 'editStudent', 'resetPassword', 'changeClass'],
      dialogTitle: '新增学生',
      dialogType: 'newStudent',
      dialogVisible: false,
      dialogForm: {
        number: '',
        name: '',
        gender: '',
        phone: '',
        classId: ''
      },
      phoneRule: this.setFormOptions().phoneRule,
    }
  },
  created() {
    this.getMajorName();
    this.getStudentInformation();
    this.tableHeight = comMethod.getTableHeight(160);
    this.initDialogFormData();
  },
  methods: {
    formatDate,
    initDialogFormData() {
      this.dialogForm = {
        number: '',
        name: '',
        gender: null,
        phone: '',
        classId: ''
      };
    },
    validateForm(formName) {
      return new Promise( resolve => {
        this.$refs[formName].validate( valid => {
          if (valid) {
            resolve(true);
          } else {
            this.$message.error('请检查必填项');
            resolve(false);
          }
        });
      });
    },
    setFormOptions() {
      return {
        phoneRule: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const phoneReg = /^1[3-9]\d{9}$/;
              if (!value) {
                callback(new Error(" "));
              } else if (!phoneReg.test(value)) {
                callback(new Error("请输入正确的11位手机号"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"]
          }
        ]
      }
    },
    async getStudentInformation() {
      try {
        const res = await studentCenterServer.queryPlatformStudentList({...this.searchForm});
        const { code, data, message } = res;
        if (code === '0') {
          this.tableData.list = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    handleAddStudent() {
      this.dialogTitle = '新增学生';
      this.dialogType = this.dialogTypeArr[0];
      this.initDialogFormData();
      this.handleOpenDialog();
    },
    async handleEditStudent(row) {
      this.studentId = row.userId;
      const backendData = await this.queryStudentById();
      if(!backendData) return;
      this.dialogTitle = '修改信息';
      this.dialogType = this.dialogTypeArr[1];
      this.initDialogFormData();
      let form = {
        number: backendData.studentNo,
        name: backendData.name,
        gender: backendData.gender === 0 ? 'male' : 'female',
        phone: backendData.account
      };
      this.dialogForm = { ...this.dialogForm, ...form };
      this.handleOpenDialog();
    },
    async handleResetPassword(row) {
      this.studentId = row.userId;
      await this.$confirm('确定要重置该学生的密码吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      });
      await this.resetPassword();
    },
    async handleChangeClass(row) {
      this.studentId = row.userId;
      this.classId = row.gradeId;
      await this.getClassName();
      this.dialogTitle = '更换班级';
      this.dialogType = this.dialogTypeArr[3];
      this.dialogForm.classId = '';
      // this.initDialogFormData();
      this.handleOpenDialog();
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm?.clearValidate();
      });
    },
    studyDetails (row) {
      this.rowIndex = row.index;
      let rourteUrl = this.$router.resolve({
        path: 'StudentStudyDetails',
        query: { id: row.userId }
      });
      window.open(rourteUrl.href, '_blank');
    },
    async dialogHandleConfirm() {
      let valid = await this.validateForm('dialogForm');
      if(!valid) return;
      this.dialogVisible = false;
      switch (this.dialogType) {
        case this.dialogTypeArr[0]:
          await this.addStudent();
          break;
        case this.dialogTypeArr[1]:
          await this.editStudent();
          break;
        case this.dialogTypeArr[2]:
          await this.resetPassword();
          break;
        case this.dialogTypeArr[3]:
          await this.changeClass();
          break;
        default:
          break;
      }
    },
    initBackendForm() {
      return {
        name: this.dialogForm.name,
        studentNo: this.dialogForm.number,
        gender: this.dialogForm.gender === 'male' ? 0 : this.dialogForm.gender === 'female' ? 1 : null,
        mobile: this.dialogForm.phone,
        gradeId: this.classId
      }
    },
    async queryStudentById() {
      const res = await studentServer.studentDetail({ userId: this.studentId });
      return res.data || null;
    },
    async addStudent() {
      const form = this.initBackendForm();
      try {
        const res = await studentServer.studentAdd({ ...form });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentInformation();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async editStudent() {
      const form = this.initBackendForm();
      try {
        const res = await studentServer.studentUpdate({...form, id: this.studentId });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentInformation();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async resetPassword() {
      try {
        const res = await studentServer.studentResetPassword({ userId: this.studentId });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentInformation();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async changeClass() {
      try {
        const res = await studentServer.studentChangeClass({
          userId: this.studentId,  
          gradeId: this.dialogForm.classId
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentInformation();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async getClassName () {
      try {
        const res = await classServer.classNameList();
        const { code, data, message } = res;
        if (code === '0') {
          this.classNameOptions = data.filter(item => item.id !== this.classId);
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    // 获取专业数据
    async getMajorName () {
      try {
        const res = await keyServer.profession({
          dictionaryKey: 'profession'
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.majorNameOptions = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    handlePageChange (pageIndex, obj = {}) {
      this.getStudentInformation();
    },
    // handleChange(value) {
    //   // 手动收起下拉框
    //   this.$nextTick(() => {
    //     this.$refs[value].dropDownVisible = false; // 收起下拉框
    //   })
    //   this.handlePageChange();
    // },
    keyDownEnter (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.student-manage {
  width: 100%;
  height: 100%;
  .top-identify-content {
    padding: 20px 20px 8px 20px;
    .bold-type {
      font-size: 20px;
      font-weight: bold;
    }
    .bold-type-stu {
      font-size: 15px;
      font-weight: bold;
    }
    .above {
      margin-bottom: 10px;
      display: inline-block;
    }
    .margin-rgt {
      margin-right: 30px;
    }
  }
  .class-form {
    width: 90%;
    .class-change-prompt {
      // color: #9e2b28;
      color: red;
      margin-bottom: 27px;
    }
    .reset-password-prompt {
      // color: red;
      // font-weight: bold;
      font-size: 16px;
    }
  }
  .import-dialog {
    .error-message {
      text-align: left;
      .title {
        margin: 10px 0;
        font-size: 17px;
        font-weight: bold;
      }
      .content {
        margin: 20px;
      }
      .tips {
        font-size: 17px;
      }
    }
  }
}
</style>

<style lang="scss">
.student-manage {
  .el-dialog__body, .my-scroll {
      overflow: auto;
      padding-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/studentCenter/studentManage.vue